import { render } from "./CurriculumPageHeading.vue?vue&type=template&id=574ebfc4&ts=true"
import script from "./CurriculumPageHeading.vue?vue&type=script&lang=ts"
export * from "./CurriculumPageHeading.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__